define(function(require, exports, module) {
    'use strict';

    module.exports = {
        notify: function(options = {}) {
            window.Playtech.API.popup.showPopup('confirmation', {
                layer: 'SESSION_VALIDATION',
                isModal: true,
                title: 'playtech.mobile.system.popup.fitToPlay.title',
                content: 'playtech.mobile.system.popup.fitToPlay.text',
                acceptBtnText: 'playtech.mobile.system.message.confirm',
                declineBtnText: 'playtech.mobile.system.message.decline',
                ...options.data,
            });
        }
    };
});
